import { render, staticRenderFns } from "./DocsSidebar.vue?vue&type=template&id=59f5c700&scoped=true&"
import script from "./DocsSidebar.vue?vue&type=script&lang=js&"
export * from "./DocsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DocsSidebar.vue?vue&type=style&index=0&id=59f5c700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f5c700",
  null
  
)

export default component.exports